import axios from "@/axios";
import {AdminType,AmdinResponse}  from "@/types/admin"
import {ILoginParmas,ILoginDataModel,IUserInfoModel,IRegisterParmas} from "@/types/admin"
// 
export const LoginApi = (parmas: ILoginParmas): Promise<IResponse<ILoginDataModel>> => axios.post('/eduservice/admin/login', parmas)


export const userInfoApi = (): Promise<IResponse<IUserInfoModel>> => axios.get("/eduservice/admin/info")

export const registerApi = (register: IRegisterParmas): Promise<IResponse<"">> => axios.post("/users/register", register);

export const getAdmin = async (
    current: number = 1,
     limit: number = 10,
  ): Promise<AmdinResponse> => {
   let url = `eduservice/admin/AdminList/${current}/${limit}`;
   const response = await axios.get(url);
   return response.data;
  }

  export const getSuperAdmin = async (
    current: number = 1,
     limit: number = 10,
  ): Promise<AmdinResponse> => {
   let url = `eduservice/admin/superAdminList/${current}/${limit}`;
   const response = await axios.get(url);
   return response.data;
  }


  export const getAllAdmins = async () => {
    try {
      const response = await axios.get("eduservice/admin");
      return response.data;
    } catch (error) {
      console.error('获取管理员列表失败', error);
      return null;
    }
  };
  
  export const createAdmin = async (admin: { username: string; password: string; role: string }) => {
    try {
      const response = await axios.post("eduservice/admin", admin);
      return response.data;
    } catch (error) {
      console.error('创建管理员失败', error);
      return null;
    }
  };
  
  export const updateAdmin = async (admin: { id: string; username: string; password: string; role: string }) => {
    try {
      const response = await axios.put("eduservice/admin", admin);
      return response.data;
    } catch (error) {
      console.error('更新管理员信息失败', error);
      return null;
    }
  };
  
  export const deleteAdmin = async (id: string) => {
    try {
      const response = await axios.delete(`eduservice/admin/${id}`);
      return response.data;
    } catch (error) {
      console.error('删除管理员失败', error);
      return null;
    }
  };  


// 假设在某个组件或者函数中调用登录接口
// const handleLogin = async () => {
//     const loginParams = {
//       // 这里填写登录所需的参数
//       username: 'yourUsername',
//       password: 'yourPassword'
//     };
  
//     try {
//       const response = await LoginApi(loginParams);
//       const token = response.data.data.token; // 假设返回的数据结构中 token 在这个位置
//       localStorage.setItem('token', token);
//       // 登录成功后的其他操作，比如跳转到主页等
//       console.log('登录成功，token 已保存');
//     } catch (error) {
//       console.error('登录失败:', error);
//     }
//   };